import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container, Header } from 'semantic-ui-react';
import styled from 'styled-components';
import { PageHeader, Wrappers } from '../components';
import { withAuth, AuthRoles } from '../auth';
import './SuretrackReferral.css';

const StyledIFrame = styled.iframe`
  background: #fff;
  padding: 12px 12px;
  border: none;
  border-radius: 6px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.08);
  overflow-x: none;
  overflow-y: none;
`;

const Surface = styled.div`
  padding: 24px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.08);
  background: #fff;
  border-radius: 6px;
  maxwidth: 768px;
`;

const IneligibleMessage = () => {
  return (
    <Surface>
      <h1>Sorry!</h1>
      <p>This program is only available to Canadian Westeel dealers.</p>
      <Link to="/">Return to our home page</Link>
    </Surface>
  );
};

const SuretrackReferral = ({ authUser }) => {
  const isAGIUser = AuthRoles.isAGIUser(authUser, 'roles');
  const {
    givenName,
    lastName,
    email,
    dealer: { address }
  } = authUser;

  const userIsEligible = () => {
    const { country, brands } = authUser;
    if (isAGIUser) return true;
    if (country !== 'CA' || !brands.includes('-WSTEL-')) return false;
    return true;
  };

  return (
    <Wrappers.Layout menu>
      <Container as="main">
        <PageHeader overlap>
          <Header as="h1" data-qa="warranty-claims-header">
            <small>Dealer Referral Program</small>
            SureTrack
          </Header>
        </PageHeader>
        {userIsEligible() ? (
          <StyledIFrame
            onload={window.parent.scrollTo(0, 0)}
            id="ft1631800990259-664-54"
            allowtransparency={true}
            src={`https://aggrowth.formtitan.com/ft7b57e4fc1631548547118?fld33=${email}&fld2-FirstName=${givenName}&fld2-LastName=${lastName}&fld42=${address ||
              ''}`}
            frameborder={0}
            width={720}
            height={900}
            scrolling="no"
          />
        ) : (
          <IneligibleMessage />
        )}
      </Container>
    </Wrappers.Layout>
  );
};

SuretrackReferral.propTypes = {
  authUser: PropTypes.shape({
    brands: PropTypes.arrayOf(PropTypes.string),
    country: PropTypes.string
  }).isRequired
};

export default withAuth(SuretrackReferral);
